<template>
  <v-dialog
    scrollable
    v-model="isShowDialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-app-bar
      dark
      color="black"
      fixed
      dense
    >
      <!-- <v-btn icon dark @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn> -->
      <v-toolbar-title>
        公告 ({{carousel+1}}/{{activeAnnouncementList.length}})
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        icon
        dark
        @click="close"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-app-bar>
    <v-card
      style="padding-top: 48px !important;"
      tile
    >
      <v-carousel
        v-model="carousel"
        height="calc(100vh - 48px)"
        hide-delimiter-background
        hide-delimiters
        show-arrows-on-hover
      >
        <v-carousel-item
          v-for="(announcement, i) in activeAnnouncementList"
          :key="i"
        >
          <v-container
            style="overflow-y: scroll"
            height="100%"
          >
            <v-row
              class="fill-height"
              align="center"
              justify="center"
            >
              <v-col cols="12">
                <div class="display-3">
                  {{announcement.Title}}
                  <v-fade-transition>
                    <v-chip
                      v-show="isUnread(announcement)"
                      color="red"
                      small
                    >NEW</v-chip>
                  </v-fade-transition>
                  <v-fade-transition>
                    <v-chip
                      v-show="announcement.justReaded"
                      color="primary"
                      small
                    >剛剛已讀</v-chip>
                  </v-fade-transition>
                </div>
              </v-col>
              <v-col cols="12">
                <avatar
                  v-for="(user) in getReadedUsers(announcement)"
                  :key="`avatar-readed-user-${user.ID}`"
                  class="ml-1 mr-1"
                  :user="user"
                />
              </v-col>
              <v-col cols="12">
                <p>{{announcement.Content}}</p>
              </v-col>
            </v-row>
          </v-container>
        </v-carousel-item>
      </v-carousel>

    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import Avatar from "@/ui/components/avatar.vue";
export default {
  components: { Avatar },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    id: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    isLoading: true,
    fab: false,
    carousel: null
  }),
  computed: {
    isShowDialog: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      }
    },
    activeAnnouncementList() {
      return this.$store.state.announcement.list.filter(o => o.IsActive);
    },
    ...mapGetters(["me", "users"])
  },
  methods: {
    getReadedUsers(announcement) {
      return this.users.filter(
        o =>
          announcement.ReadedUserIDList &&
          announcement.ReadedUserIDList.includes(o.ID)
      );
    },
    close() {
      this.isShowDialog = false;
    },
    isUnread(announcement) {
      return (
        !announcement.ReadedUserIDList ||
        !announcement.ReadedUserIDList.includes(this.me.ID)
      );
    },
    read(announcement) {
      this.$services.announcement.read(this, announcement.ID).then(() => {
        this.$set(announcement, "justReaded", true);
        this.$set(
          announcement,
          "ReadedUserIDList",
          (announcement.ReadedUserIDList || []).concat([this.me.ID])
        );
      });
    }
  },
  created() {},
  watch: {
    isShowDialog(val) {
      if (val)
        this.carousel =
          this.activeAnnouncementList.findIndex(o => o.ID == this.id) || 0;
    },
    carousel() {
      var idx = parseInt(this.carousel);
      if (typeof idx !== "number") return;
      if (idx < 0) return;

      let announcement = this.activeAnnouncementList[idx];
      let isUnread = this.isUnread(announcement);

      if (isUnread) this.read(announcement);
    }
  }
};
</script>

<style scoped>
.deleted {
  text-decoration: line-through;
}
</style>